module.exports = __webpack_public_path__ + "img/Gold Nova III.495cf655.png";